import Slider from './Slider';

/**
 *  Constuctor accepts a container div/element for the entire multislider. This container
 *  keeps the functionality containerized, so that multiple multisliders can exist on the 
 *  same page.
 * 
 *  '.slideshow-button-container' => class name for buttons
 *  '.slideshow-category-container' => class name for each individual slider in the multislider
 *  '.slideshow-images' => class name which directly holds all of the images in each individual slider
 * 
 *  Should look something like this:
 * 
 *  <div class="multislider">
 *      <div class='buttons'>
 *          <div class="slideshow-button-container"></div>
 *          <div class="slideshow-button-container"></div>
 *      </div>
 *      <div class="slideshow-category-container">
 *          <div class="slideshow-images">
 *              <div class="slideshow-image-container"></div>
 *              <div class="slideshow-image-container"></div>
 *          </div>
 *      </div>
 *      <div class="slideshow-category-container">
 *          <div class="slideshow-images">
 *              <div class="slideshow-image-container"></div>
 *              <div class="slideshow-image-container"></div>
 *          </div>
 *      </div>
 *  </div>
 */
export default class MultiSlider {
    
    constructor(sliderElement){
        this.slider = sliderElement;
        this.sliders = [];
        
        if(sliderElement){
            this.buttons = sliderElement.querySelectorAll('.slideshow-button-container');
            this.categories = sliderElement.querySelectorAll('.slideshow-category-container');

            this.initialize();
        }
    }

    /**
     *  Event listeners
     */
    initialize(){
        this.categories.forEach(category => {
            let imageContainer = category.querySelector('.slideshow-images');
            let slider = new Slider(imageContainer);

            this.sliders.push(slider);
        });

        let self = this;
        this.buttons.forEach(function(button){
            button.addEventListener('click', function(){
                self.showCategory(this.dataset.categoryIndex);
            });
        });
    }

    /**
     *  This function will hide all sliders except the active slider, defined by index
     *  
     *  The biggest flaw here is that they are hidden with opacity, which poses some accessibility issues.
     */
    showCategory(index){
        if(index >= this.categories.length){
            index = this.categories.length - 1;
        } else if(index < 0){
            index = 0;
        }

        let category, button, categoryIndex, buttonIndex;
        for(let i = 0; i < this.categories.length; i++){
            category = this.categories[i];
            categoryIndex = category.dataset.categoryIndex;

            button = this.buttons[i];
            buttonIndex = button.dataset.categoryIndex;

            category.className = category.className.replace(/ active/g, '');
            button.className = button.className.replace(/ active/g, '');


            if(index == categoryIndex){
                category.className += ' active';
            }

            if(index == buttonIndex){
                button.className += ' active';
            }
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/class/MultiSlider.js